import { useState } from 'react';
import { toast } from 'react-toastify';
import { postWithoutToken, setLocalStorage } from '../../API/Api';
import { validateEmail } from '../../assets/Helper/utils';
import { SESSION_PATHS } from '../../routes/paths';
import LOGO from '../../assets/images/comniqAI/comniq-logo-dark.svg';
import MOCKUP from '../../assets/images/comniqAI/mockup.svg';
import AuthLayout from './AuthLayout';
import { MdEmail } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import ButtonLoader from '../../components/ButtonLoader';

const ValidationErrors = {
  empty: {
    email: 'Email id Required',
  },
  invalid: {
    email: 'Invalid Email',
  },
};

const ForgotPassword = () => {
  const Navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [values, setValues] = useState({
    email: '',
  });

  const [errors, setErrors] = useState({
    email: '',
  });

  const { email } = values;

  const handleChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const handleClick = () => {
    setLoader(true);
    const tempErrors = { ...errors };
    Object.keys(values).forEach((key) => {
      if (!values[key]) {
        tempErrors[key] = ValidationErrors.empty[key];
      } else {
        if (key === 'email' && !validateEmail(values[key])) {
          tempErrors.email = ValidationErrors.invalid.email;
        }
      }
    });
    setErrors(tempErrors);

    if (Object.values(tempErrors).filter((obj) => !!obj).length > 0) {
      setLoader(false);
      return false;
    }
    postWithoutToken('forgetpassword_mail', values)
      .then((response) => {
        if (response.status === 200) {
          toast.success(response.message);
          setLocalStorage('userEmail', response?.data?.email);
          Navigate(SESSION_PATHS.OTP_VERIFICATION('forgot'));
        } else if (response.status === 400) {
          toast.error(response.message);
        }
      })
      .catch((error) => {
        toast.error('Something went wrong');
      })
      .finally(() => {
        setLoader(false);
      });
  };
  const onFormSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <>
      <AuthLayout title='Forgot password' subtitle='Back to' linkText='Sign in' linkTo={SESSION_PATHS.LOGIN} LeftImage={MOCKUP} Logo={LOGO}>
        {/* Form */}
        <form onSubmit={onFormSubmit}>
          <div className='form-group position-relative input-GPT'>
            <label htmlFor='email' className='auth-label outfit-semibold'>
              Email*
            </label>
            <div className='input-with-icon'>
              <MdEmail className='input-icon' />
              <input type='text' className='form-control auth-input' id='email' name='email' value={email} placeholder='Email' autoComplete='off' onChange={handleChange} />
            </div>
            {errors.email && <p className='text-danger insta-smart-error'>{errors.email}</p>}
          </div>

          {/* Submit Button and Back Link */}
          <div className='d-flex flex-wrap align-items-center justify-content-between pt-2 gap-2'>
            <button type='submit' className='btn-submit-login outfit-bold max-width-100 d-flex align-items-center justify-content-center gap-2' onClick={handleClick}>
              {loader && <ButtonLoader />}

              <span className='outfit-bold'>Send Mail</span>
            </button>
            {/* <div className='text-end'>
              <span className='me-2 outfit-regular'>Back to</span>
              <Link to={SESSION_PATHS.LOGIN} className='auth-link outfit-bold text-decoration-none'>
                Sign in
              </Link>
            </div> */}
          </div>
        </form>
      </AuthLayout>
    </>
  );
};

export default ForgotPassword;
